import { render, staticRenderFns } from "./MailboxSidebar.vue?vue&type=template&id=1b081f71&"
import script from "./MailboxSidebar.vue?vue&type=script&lang=js&"
export * from "./MailboxSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b081f71')) {
      api.createRecord('1b081f71', component.options)
    } else {
      api.reload('1b081f71', component.options)
    }
    module.hot.accept("./MailboxSidebar.vue?vue&type=template&id=1b081f71&", function () {
      api.rerender('1b081f71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/apps/mailbox/MailboxSidebar.vue"
export default component.exports